import React, {  useEffect } from 'react';
import { useSelector, } from 'react-redux';
import { FloatingWhatsApp } from 'react-floating-whatsapp';

const WhatsappComponent = () => {
  const enlaces = useSelector(state => state.enlaces);

  const numeroWhatsapp = enlaces.find(w => w.Id === "WHATSAPP_NUMERO")?.URL === undefined ? "000000000" : enlaces.find(w => w.Id === "WHATSAPP_NUMERO")?.URL;
  const fraseCaja = enlaces.find(w => w.Id === "WHATSAPP_MENSAJE_BASE")?.URL === undefined ? "" : enlaces.find(w => w.Id === "WHATSAPP_MENSAJE_BASE")?.URL;
  const mensajeBase = enlaces.find(w => w.Id === "WHATSAPP_ESCRIBE")?.URL === undefined ? "Escribe aquí" : enlaces.find(w => w.Id === "WHATSAPP_ESCRIBE")?.URL;
  const nombreAsistente = enlaces.find(w => w.Id === "WHATSAPP_ASISTENTE")?.URL === undefined ? "InterAmerican" : enlaces.find(w => w.Id === "WHATSAPP_ASISTENTE")?.URL;
  const estadoWhastapp = enlaces.find(w => w.Id === "WHATSAPP_ESTADO")?.URL === undefined ? "En línea" : enlaces.find(w => w.Id === "WHATSAPP_ESTADO")?.URL;
  const fraseAsistente = enlaces.find(w => w.Id === "WHATSAPP_FRASE")?.URL === undefined ? "Hola! 👋 Estoy aquí para ayudarte con cualquier consulta que tengas." : enlaces.find(w => w.Id === "WHATSAPP_FRASE")?.URL;
  const avatarChat = enlaces.find(w => w.Id === "WHATSAPP_CAJA_ICONO")?.URL === undefined ? "/images/whatsappchatboot.jpg" : '/images/' + enlaces.find(w => w.Id === "WHATSAPP_CAJA_ICONO")?.URL;

  useEffect(() => {
    
    const inputElement = document.querySelector('.styles-module_input__WFb9L');

    if (inputElement) {
      inputElement.value = fraseCaja; // Cambia el valor del input
    }
  }, [fraseCaja]);


  return (
    <div>

      <FloatingWhatsApp
        avatar={avatarChat}
        phoneNumber={numeroWhatsapp}  
        accountName={nombreAsistente}
        chatMessage={fraseAsistente}
        statusMessage={estadoWhastapp}
        allowEsc={true} // Optional
        chatboxHeight={300}
        placeholder={mensajeBase}
        className="floating-whatsapp"
      />
    </div>
  );
};

export default WhatsappComponent;
